module.exports = __webpack_public_path__ + "static/img/s2.de71f2c6.png";